<div class="flex flex-col gap-1">
  <label *ngIf="label" class="text-sm font-medium leading-none text-gray-700">
    {{ label | translate }}
    <span *ngIf="required" class="text-brand-red ml-0.5">*</span>
  </label>
  <div
    #editorContainer
    class="w-full rounded overflow-hidden border bg-[#1e1e1e]"
    [class.border-gray-300]="!(control?.invalid && control?.touched)"
    [class.border-brand-red]="control?.invalid && control?.touched"
    [style.height]="height"
    [class.opacity-50]="isDisabled"
    [class.pointer-events-none]="isDisabled"
  ></div>
  <span
    *ngIf="control?.errors?.['monacoErrors'] && control?.touched"
    class="text-xs text-brand-red mt-0.5">
    {{ 'global.validations.generic' | translate }}
  </span>
</div>
